import $ from "cash-dom"

$(() => {
  const doc = $(document)
  doc.on({
    click(event) {
      const isLeftButton = event.which === 1
      if (isLeftButton) {
        doc.trigger("document:click", event.target)
      }
    },
    keyup(event) {
      if (event.keyCode === 27) {
        doc.trigger("document:keyup:escape")
      }
    },
  })
})
